import type { FunctionComponent } from 'react';
import { MetromapLogo, StyleAerialImageComponent } from '../../MediaShowcaseBrick.styled';
import metroMapOverlaySvg from '../../../../../assets/metromap-overlay.svg';

interface AerialShowcaseImage {
  href: string;
  alt: string;
}

export const AerialShowcaseImage: FunctionComponent<AerialShowcaseImage> = ({ href, alt }) => {
  return (
    <>
      <StyleAerialImageComponent src={href} alt={alt} />
      <MetromapLogo alt="metromap-logo" src={metroMapOverlaySvg} />
    </>
  );
};
